export const timers: Record<string, number> = {
  SUBMIT_TIMEOUT_MS: 3000,
  LOADER_TIMEOUT: 1,
}
